import React, { PureComponent } from 'react';
import { PrimaryButton, DLTextField } from 'appSrc/components/UI';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AdminPageHead extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            searchValue: '',
        };
    }
    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            if( this.props.onSearch ) {
                this.props.onSearch( this.state.searchValue );
            }
        }
    }
    testLocation = ( url ) => {
        var reg = new RegExp( `^${ url }/?(?:\\\?.*)?(?:#.*)?$` );
        return reg.test( window.location.pathname );
    }

    render() {
        const { searchValue } = this.state;

        return (
            <div className={ style.head }>
                <h2>{ this.props.title }</h2>
                <div className={ style.controls }>
                    { this.props.onSearch &&
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                    }
                    { this.props.buttons.map( ( button, index ) => {
                        return ( <PrimaryButton { ...button } key={ `control-button-${ index }` } /> );
                    } ) }
                </div>
                <div className={ style.tabs }>
                    { this.props.tabs.map( ( tab ) => {
                        return ( <Link to={ tab.to } className={ style.tabOption }
                            data-active={ this.testLocation( tab.to ) }
                            key={ `${ tab.label }:${ tab.to }` }>{ tab.label }</Link> );
                    } ) }
                </div>
            </div>
        );
    }
}
AdminPageHead.defaultProps = {
    title: '',
    buttons: [],
    tabs: [],
};

export default AdminPageHead;
